 import { useCallback, useContext, useMemo } from "react";
import { Button, Col, Dropdown, Image, ProgressBar, Row } from "react-bootstrap";
import { WorkspaceListContext } from "../../contexts/WorkspaceListContext";
import { useDispatch, useSelector } from "react-redux";
import { State } from "linkifyjs";
import { adminBaseURL } from "../../utils/commonUtils";
import { sidebarConstants } from "../../constants/sidebar.constants";
import useLeaveWorkspaceHooks from "../../hooks/useLeaveWorkspaceHooks";
import { PopupAlert } from "../PopupAlert";
import useDeleteWorkspacePopupHook from "../../hooks/useDeleteWorkspacePopupHook";
import { Link } from 'react-router-dom';
import SettingsIcon from '../../images/icons/dark/settings.svg';
import useEditWorkspacePopupHook from "../../hooks/useEditWorkspacePopupHook";
import WorkSpaceEdit  from '../../App/screens/WorkSpacePage/edit';
import { Popup } from "../Popup";
import { organizationActions, work_spaceActions } from "../../actions";
import WorkspaceLockLabel from "../workspace_lock/components/WorkspaceLockLabel";
import WorkspaceFileLimitBar from "components/workspace/WorkspaceFileLimitBar";

function progressBarVariant(total_size){
  if(total_size <= 49){
    return 'success'
  } else if (total_size <= 50 && total_size < 80) {
    return `warning`
  } else {
    return 'danger'
  }
}

function SortedWorkspace({
    sorted_workspaces
}) {

    // Context
    const { handleShowNewForm } = useContext(WorkspaceListContext);

    // Redux
    const { 
        can_create_workspace, 
        organizations 
    } = useSelector(state => state.organization);
    const {
        initialData,
        work_space_error,
        workspace_dropdown_loading,
    } = useSelector(state => state.work_space);
    const { 
        selected_organization, 
        selected_tab 
    } = useSelector(state => state.sidebar);


    // Hooks
    const { 
        leaveWorkspacePopupData,
        handleCloseLeaveWorkspacePopup, 
        handleOpenLeaveWorkspacePopup 
    } = useLeaveWorkspaceHooks();
    const {
        deleteWorkspacePopup,
        handleShowDeleteWorkspacePopup,
        handleCloseDeleteWorkspaceForm,
        handleDeleteWorkspace
    } = useDeleteWorkspacePopupHook();
    const {
        editWorkspacePopup,
        handleEditWorkspaceShowForm,
        handleCloseWorkspaceEditForm
    } = useEditWorkspacePopupHook();
    
    // Variables
    const dispatch = useDispatch();
    const workspaceBaseUrl = adminBaseURL("workspaces");
    const hasWorkspace = sorted_workspaces && sorted_workspaces.length > 0;
    const default_modes = sidebarConstants.DEFAULT_MODES

    // Functions
    const getOrganizationName = useMemo(() => (org_id) => {
        if (organizations.length > 0 && org_id){
            let organization = organizations.find((org) => org.id === org_id)

            if(organization){
                return organization.name
            }
        }
    }, [organizations]);

    const handleLeaveWorkspace = useCallback(() => {
        const finallyFunc = () => {
            handleCloseLeaveWorkspacePopup();
        };

        const successFunc = () => {
            dispatch(organizationActions.getWorkspaces(selected_organization));
        };

        dispatch(work_spaceActions.leaveWorkspace(leaveWorkspacePopupData.id, successFunc, finallyFunc));

    }, [dispatch, leaveWorkspacePopupData.id, selected_organization, handleCloseLeaveWorkspacePopup]);
    

    if(!hasWorkspace && !workspace_dropdown_loading){
        return (
              <div className="text-center py-4">
                {
                    can_create_workspace
                    ?
                    <>
                        <h3>Welcome to your new organization.</h3>
                        <p><Button onClick={handleShowNewForm} variant="primary" size="sm">Create your first workspace.</Button></p>
                    </>
                    :
                    <p>No workspaces available yet.</p>
                }
            </div>
        )
    }

    return (
        <>
            {
                sorted_workspaces.map((data, index) => {
                    const organization = organizations?.find(org => data.organization_id === org.id);


                    return(
                        <Col sm={"12"} className="mb-3 card workspace_card" key={index}>
                            <Row>
                            <Col sm={"12"} xl={"2"} style={{padding: 0}}>
                                { data.logo &&
                                <Link to={{ pathname: `/organizations/${data.organization_id}${workspaceBaseUrl}/${data.id}/list`}}>
                                    <div 
                                        className="workspace_card-image_container" 
                                        style={{backgroundImage:"url(" + data.logo.medium_url + ")" }} 
                                    />
                                </Link>
                                }
                            </Col>
                            <Col sm={"12"} xl={"10"} className="py-1 pl-2 workspace_card-details">
                                <Row>
                                <Col sm={"8"} className="mb-2 pt-3">
                                    <h3 className="font-weight-bold">
                                        <Link to={{ pathname: `/organizations/${data.organization_id}${workspaceBaseUrl}/${data.id}/list`}} className="py-2 workspace_card-details__title">
                                            {data.name}
                                        </Link>
                                    </h3>
                                </Col>
                                {
                                    selected_organization === default_modes[1] &&
                                    <Col className="d-flex justify-content-end align-items-center">
                                        <div
                                            className="text-right pt-3 workspace_card-organization_title"
                                        >
                                            {
                                                organization?.name
                                            }
                                        </div>
                                        <WorkspaceLockLabel organization={organization}/>
                                    </Col>

                                }
                                </Row>
                                <Row>
                                <Col md={5} className="mb-3">
                                    <div  className="mb-2">
                                    <div><span>{data?.unread_notifications_count || 0} </span> Unread Notifications</div>
                                    </div>

                                    <div><span>{data?.message_count || 0} </span> New Messages</div>
                                </Col>
                                <Col md={5}>
                                    <div  className="mb-2">
                                    <div><span>{data?.content_group_pending_approval_count || 0} </span> Pending Approval</div>
                                    </div>
                                    <div>
                                    <div><span>{data?.content_group_pending_revision_count || 0} </span> Pending Revision</div>
                                    </div>
                                </Col>
                                </Row>
                            </Col>
                            </Row>

                            <div
                            className="d-flex flex-row-reverse align-items-center workspace-side_details mx-2"
                            >
                            { /*// TODO:  Add setting and delete. Updating workspace should update on the list*/ }
                            {
                                (selected_tab === default_modes[0] || selected_tab === default_modes[1] || data?.can_access_update_workspace || data?.can_access_leave_workspace) &&
                                <Dropdown className="d-inline-block">
                                <Dropdown.Toggle id="dropdown-basic" className="p-2 btn-transparent" title="Options">
                                    <Image src={SettingsIcon} height={18}/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{right: "auto"}}>
                                    {
                                    data.can_access_update_workspace &&
                                    <Button
                                        variant="secondary"
                                        className="dropdown-item"
                                        onClick={() => handleEditWorkspaceShowForm(data.id)}
                                        size={'sm'}
                                    >
                                        Settings
                                    </Button>
                                    }

                                    {
                                    data.can_access_leave_workspace &&
                                    <Button
                                        variant="secondary"
                                        className="dropdown-item"
                                        onClick={() => handleOpenLeaveWorkspacePopup(data.id)}
                                        size={'sm'}
                                    >
                                        Leave Workspace
                                    </Button>
                                    }
                                    {
                                    data.can_access_destroy_workspace &&

                                    <Button
                                        variant="secondary"
                                        className="dropdown-item"
                                        onClick={() => handleShowDeleteWorkspacePopup(data.id)}
                                        size={'sm'}
                                    >
                                        Delete
                                    </Button>
                                    }

                                </Dropdown.Menu>
                                </Dropdown>
                            }

                            {
                                organization?.personal &&
                                <WorkspaceFileLimitBar workspace={data}/>
                            }
                            </div>

                        </Col>
                    )

                })
            }

            
            {deleteWorkspacePopup.show &&
                <Popup
                    handleClose={handleCloseDeleteWorkspaceForm}
                    handleDelete={handleDeleteWorkspace}
                />
            }

            {
                leaveWorkspacePopupData.show &&
                <PopupAlert
                    show={leaveWorkspacePopupData.show}
                    handleClose={handleCloseLeaveWorkspacePopup}
                    handleSubmit={handleLeaveWorkspace}
                    display_text={"Are you sure you want to leave this workspace?"}
                    btn_text={"Leave"}
                    hasClose
                />
            }

            {
                editWorkspacePopup.show &&
                <WorkSpaceEdit
                    initialData={initialData}
                    workspace_id={editWorkspacePopup.id}
                    handleCloseEditForm={handleCloseWorkspaceEditForm}
                    work_space_error={work_space_error}
                />
            }
        </>
    )

}

export default SortedWorkspace;